var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOmega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M448 456C448 469.25 437.25 480 424 480H320C306.75 480 296 469.25 296 456V431.5C296 422.75 300.781 414.656 308.469 410.469C364.938 379.5 400 320.312 400 256C400 158.969 321.031 80 224 80S48 158.969 48 256C48 320.312 83.062 379.5 139.531 410.469C147.219 414.656 152 422.75 152 431.5V456C152 469.25 141.25 480 128 480H24C10.75 480 0 469.25 0 456S10.75 432 24 432H85.406C32 389.906 0 325.312 0 256C0 132.5 100.5 32 224 32S448 132.5 448 256C448 325.312 416 389.906 362.594 432H424C437.25 432 448 442.75 448 456Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOmega);
export default __webpack_public_path__ + "static/media/omega.bf6c8585bd32f020fa186c76af208dbe.svg";
export { ForwardRef as ReactComponent };